import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Material } from "../../context/suggestionContext/suggestionTypes";
import AssetManager from "../AssetManager";

const MaterialIcons: React.FC<MaterialIconsProps> = ({ material }) => {
  const { i18n } = useTranslation();

  if (material === undefined) {
    return <></>;
  }

  function getIconIdForTog(tog: number) {
    if (tog < 0.8) {
      return 1;
    } else if (tog < 1.5) {
      return 2;
    } else if (tog < 2.5) {
      return 3;
    } else if (tog < 3.5) {
      return 4;
    } else {
      return 5;
    }
  }

  return (
    <div className="suggested-clothes-material-icons">
      <Tooltip title={i18n.t("material_water_absorption")}>
        <img
          src={AssetManager.getAsset(`/ABS_${material.waterAbsorption}.svg`)}
          alt="icon"
          className="suggested-clothes-material-icon"
        />
      </Tooltip>
      <Tooltip title={i18n.t("material_evaporation_ratio")}>
        <img
          src={AssetManager.getAsset(`/EVA_${material.evaporationRatio}.svg`)}
          alt="icon"
          className="suggested-clothes-material-icon"
        />
      </Tooltip>
      <Tooltip title={i18n.t("material_thermal_insulation")}>
        <img
          src={AssetManager.getAsset(
            `/TOG_${getIconIdForTog(material.thermalInsulation)}.svg`
          )}
          alt="icon"
          className="suggested-clothes-material-icon"
        />
      </Tooltip>
    </div>
  );
};

export default MaterialIcons;

export interface MaterialIconsProps {
  material: Material | undefined;
}
